'use client'

import styled from 'styled-components'

import { TypeStyle, untilMd } from '@syconium/little-miss-figgy'

import { usePreviewDirectives } from '../../_providers/PreviewDirectivesProvider.client'
import { usePreviewPanel } from '../../_providers/PreviewPanelProvider.client'

export const PreviewPanelLauncher = () => {
  const { togglePanel } = usePreviewPanel()
  const { includeUnpublishedCmsContent } = usePreviewDirectives()

  const handlePreviewClick = () => {
    togglePanel()
  }

  return (
    <NavItem onClick={handlePreviewClick}>
      <PreviewPanelToggle>
        Preview
        <PreviewStatus $active={includeUnpublishedCmsContent}>
          {includeUnpublishedCmsContent ? 'ON ' : 'OFF '}
        </PreviewStatus>
        <PreviewStatusIcon active={includeUnpublishedCmsContent} />
      </PreviewPanelToggle>
      <Version>v{process.env.NEXT_PUBLIC_MAGNOLIA_VERSION}</Version>
    </NavItem>
  )
}

const PreviewStatusIcon = styled.div<{ active: boolean }>`
  height: ${o => o.theme.spacing(3)};
  width: ${o => o.theme.spacing(3)};
  background-color: ${o =>
    o.active
      ? o.theme.color.stroke.celebratory.text.on.background
      : o.theme.color.fill.disabled.subtle};
  border-radius: ${o => o.theme.borderRadius.full};
`

const NavItem = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  width: 100%;
  font-size: 12px;
  cursor: pointer;
`

const PreviewPanelToggle = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;

  ${untilMd} {
    font-size: 16px; // Match legacy styles
    font-weight: 700; // Match legacy styles
  }

  &:hover {
    color: ${o => o.theme.color.text.highContrast.on.background};
  }
`

const PreviewStatus = styled.span<{ $active: boolean }>`
  color: ${o => (o.$active ? o.theme.color.stroke.celebratory.text.on.background : 'initial')};
  margin: ${o => o.theme.spacing(0, 2, 0, 1)};
`

const Version = styled.div`
  color: ${o => o.theme.color.text.tertiary.on.background};
  padding-left: ${o => o.theme.spacing(5)};

  ${untilMd} {
    ${TypeStyle.css.bodyLarge}
  }
`
